import {LEAGUES} from "../constants/leagues";

export const LEAGUE_CONFIGS = [
  {id: LEAGUES.BRONZE, name: 'Бронзовая лига', minRating: 0, iconPath: '/img/icons/league_bronze.png'},
  {id: LEAGUES.SILVER, name: 'Серебряная лига', minRating: 500, iconPath: '/img/icons/league_silver.png'},
  {id: LEAGUES.GOLD, name: 'Золотая лига', minRating: 1500, iconPath: '/img/icons/league_gold.png'},
  {id: LEAGUES.DIAMOND, name: 'Алмазная лига', minRating: 3000, iconPath: '/img/icons/league_diamond.png'},
  {id: LEAGUES.RUBY, name: 'Рубиновая лига', minRating: 5000, iconPath: '/img/icons/league_ruby.png'},
  {id: LEAGUES.GOD, name: 'Божественная лига', minRating: 10000, iconPath: '/img/icons/league_god.png'},
];


/**
 * Конфиг лиги по ее id (имя и иконка). Неизвестная лига и ее отсутствие —
 * null: значок лиги просто не показывается (см. SpectatorsModal)
 *
 * @param {string} [leagueId]
 * @returns {{id: string, name: string, minRating: number, iconPath: string}|null}
 */
export const getLeagueConfig = (leagueId) => (
  LEAGUE_CONFIGS.find((league) => league.id === leagueId) || null
);
